import React from 'react';
import Moment from 'react-moment';

export const DateTimeDisplay = (props:any) => (<Moment interval={0} format={"DD/MM/YYYY hh:mm a"} 
date={new Date(props.dt)}></Moment>)
